import { Link } from "react-router-dom";
import { Star, ArrowUpRight, Check, X } from "lucide-react";

const VerdictBox = ({ platform }) => (
  <div className="glass rounded-2xl p-6" data-testid="verdict-box">
    <div className="flex items-center justify-between">
      <span className="flex h-11 w-11 items-center justify-center rounded-xl font-display text-sm font-extrabold" style={{ backgroundColor: `${platform.hue}1f`, color: platform.hue }}>
        {platform.monogram}
      </span>
      <div className="text-right">
        <div className="flex items-center gap-1 justify-end">
          <Star className="h-4 w-4 fill-volt text-volt" />
          <span className="font-display text-2xl font-extrabold">{platform.rating}</span>
          <span className="text-sm text-white/40">/5</span>
        </div>
        <p className="text-[11px] uppercase tracking-widest text-volt">{platform.badge}</p>
      </div>
    </div>
    <p className="mt-4 text-sm leading-relaxed text-white/65">{platform.bestFor}</p>
    <div className="mt-4 space-y-1.5">
      {platform.pros.slice(0, 3).map((p, i) => (
        <p key={i} className="flex items-start gap-2 text-xs text-white/60"><Check className="mt-0.5 h-3 w-3 shrink-0 text-volt" strokeWidth={3} />{p}</p>
      ))}
      {platform.cons.slice(0, 1).map((c, i) => (
        <p key={i} className="flex items-start gap-2 text-xs text-white/60"><X className="mt-0.5 h-3 w-3 shrink-0 text-red-400/70" strokeWidth={3} />{c}</p>
      ))}
    </div>
    <div className="mt-5 border-t border-white/10 pt-4">
      <p className="text-xs text-white/45">From <span className="font-display text-base font-bold text-white">{platform.startingPrice}/mo</span></p>
      <p className="text-xs text-volt">{platform.trial}</p>
    </div>
    <a
      href={platform.affiliateUrl}
      target="_blank"
      rel="noopener noreferrer sponsored"
      data-testid="verdict-cta-trial"
      className="mt-4 flex items-center justify-center gap-2 rounded-full bg-volt py-3 text-sm font-bold text-ink transition-colors hover:bg-volt-hover"
    >
      Start Free Trial <ArrowUpRight className="h-4 w-4" />
    </a>
    <Link to={`/reviews/${platform.slug}`} data-testid="verdict-read-review" className="mt-2 block text-center text-xs text-white/50 underline-offset-2 hover:text-volt hover:underline">
      Read the full review
    </Link>
  </div>
);

export default VerdictBox;
